export const receiveCreditSteps = [
  'اعتبارسنجی',
  'انتخاب اعتبار',
  'تکمیل مدارک',
  // 'ساخت امضای دیجیتال',
  'امضای قرارداد',
  'دریافت اعتبار',
];
